module.exports = __webpack_public_path__ + "static/media/FantasyBackground.99bf6047.png";